<div class="tab-content match-summary live-timeline">
    <div class="py-2 pl-2">
        <span class="break-ball">BB</span> {{ 'web.break_ball' | translate }} <span class="ace">AC</span>
        {{ 'web.ace' | translate }}
        <!-- <span class="second-service">SS</span> {{ 'web.second_service' | translate }} -->
        <span class="double-fault">DF</span> {{ 'web.double_fault' | translate }} <span class="set-ball">SB</span>
        {{ 'web.set_ball' | translate }} <span class="match-ball">MB</span> {{ 'web.match_ball' | translate }}
    </div>
    @for (val of actions; track $index) {
    <div
        class="tab-pane show active"
        id="tab-match-summary-1-content"
        role="tabpanel"
        aria-labelledby="tab-match-summary-1"
    >
        <h6
            class="text-center text-uppercase match-summary__head dropdown-toggle"
            data-toggle="collapse"
            [attr.href]="'#collapseAction' + val[0]"
            role="button"
            aria-expanded="false"
            [attr.aria-controls]="'collapseAction' + val[0]"
            [class.collapsed]="isClose(val[0])"
        >
            {{ 'web.' + sportName + '_' + val[0] | lowercase | translate }}
        </h6>
        <div [attr.id]="'collapseAction' + val[0]" [class.show]="!isClose(val[0])" class="collapse show">
            @for (action of val[1]; track $index; let isLastMain = $last) {
            <div class="row no-gutters border-top py-1 px-3 small">
                <div class="col-5 align-self-center font-weight-bold font-1x text-right">
                    @if (!action.score?.tie_break) { @if ( action.score?.server === 'home' && (action.score?.result ===
                    'receiver_won' || action.score?.result === 'double_fault') ) {
                    <div class="tennis-set-match">
                        {{ 'web.lost_service' | translate }}
                    </div>
                    } @if (action.score?.server === 'home') {
                    <span class="serve serve--tennis-timeline">0</span>
                    } } &nbsp;
                </div>
                <div class="col-2 align-self-center font-weight-bold text-center font-1-1x">
                    <span [class.emph-text-node]="action.score?.isHomeWinner">{{ action.score?.home_score }}</span>
                    -
                    <span [class.emph-text-node]="!action.score?.isHomeWinner">{{ action.score?.away_score }}</span>
                </div>
                <div class="col-5 align-self-center font-weight-bold font-1x text-left">
                    @if (!action.score?.tie_break) { @if (action.score?.server === 'away') {
                    <span class="serve serve--tennis-timeline">0</span>
                    } @if ( action.score?.server === 'away' && (action.score?.result === 'receiver_won' ||
                    action.score?.result === 'double_fault') ) {
                    <div class="tennis-set-match">
                        {{ 'web.lost_service' | translate }}
                    </div>
                    } } &nbsp;
                </div>
            </div>
            <div class="row no-gutters py-1 px-3 small">
                <div class="col-12 align-self-center text-center font-0-9x">
                    @for (point of action.point; track $index; let isLast = $last) { @if (!point.matchEnded) {
                    {{ point.home_score === 50 ? 'A' : point.home_score }}:{{
                        point.away_score === 50 ? 'A' : point.away_score
                    }}
                    @if (false && point.first_serve_fault && point.result !== 'double_fault') {
                    <span class="second-service" title="{{ 'web.second_service' | translate }}">SS</span>
                    } @if (point.isBB) {
                    <span class="break-ball" title="{{ 'web.break_ball' | translate }}"> BB </span>
                    } @if (point.result === 'double_fault') {
                    <span class="double-fault" title="{{ 'web.double_fault' | translate }}">DF</span>
                    } @if (point.result === 'ace') {
                    <span class="ace" title="{{ 'web.ace' | translate }}">AC</span>
                    } @if (point.isSB && !point.isMB) {
                    <span class="set-ball" title="{{ 'web.set_ball' | translate }}">{{ mbPoint(val[1]) }}</span>
                    } @if (point.isMB) {
                    <span class="match-ball" title="{{ 'web.match_ball' | translate }}">MB</span>
                    } @if (!isLast) { , } } }
                </div>
            </div>
            }
        </div>
    </div>
    }
    <!-- <div *ngIf="data.match_suspended" class="row no-gutters border-top py-1 px-3 small">
            <div class="col-12 align-self-center font-weight-bold font-1x text-center">
              <div class="tennis-set-match text-center">{{ 'web.match_suspended' | translate }}</div>
            </div>
          </div> -->
</div>
